import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, MessageSquare, Phone } from 'lucide-react';

const Welcome = () => {
  const [firstName, setFirstName] = useState('');
  const navigate = useNavigate();
  
  useEffect(() => {
    const userDataString = sessionStorage.getItem('userData');
    
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        setFirstName(userData.firstName || '');
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    } else {
      navigate('/');
    }
  }, [navigate]);

  const handleWhatsAppContact = () => {
    window.open('https://wa.me/919850206906', '_blank');
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-2xl mx-auto text-center">
          {/* Success Icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
            <CheckCircle className="w-12 h-12 text-white" />
          </div>

          {/* Congratulations Message */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            🎉 Congratulations{firstName ? `, ${firstName}` : ''}!
          </h1>
          
          <p className="text-xl text-gray-700 mb-8">
            Your application has been successfully submitted.
          </p>

          {/* What's Next Card */}
          <div className="bg-white p-8 rounded-2xl shadow-xl mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">What Happens Next?</h2>
            <p className="text-gray-600 mb-6">
              Our team will review your application and get in touch with you within 24-48 hours to discuss the next steps for enrolling your child in the <strong>AI SuperCreators Program™</strong>.
            </p>

            <div className="bg-green-50 border border-green-200 rounded-xl p-6">
              <h3 className="font-bold text-gray-900 mb-3 flex items-center justify-center gap-2">
                <Phone className="w-5 h-5 text-green-600" />
                Have Questions?
              </h3>
              <p className="text-gray-700 mb-4">
                Reach out to us directly on WhatsApp:
              </p>
              <p className="text-2xl font-bold text-green-600 mb-4">
                +91 98502 06906
              </p>
              <button
                onClick={handleWhatsAppContact}
                className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-bold transition-colors"
              >
                <MessageSquare className="w-5 h-5" />
                Message Us on WhatsApp
              </button>
            </div>
          </div>

          {/* Motivation */}
          <div className="bg-gradient-to-r from-purple-600 to-indigo-600 p-6 rounded-xl text-white">
            <p className="text-lg font-medium">
              You've taken the first step towards giving your child an unfair advantage in the age of AI. 🚀
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;